import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CATEGORIES } from '../../../../../../@common/constants/categories.constants';
import { Category } from '../../../../../../@generated';
import { AppRoute } from '../../../../../../routing/types/app-route';

@Component({
    selector: 'app-categories',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        RouterLink
    ],
    styles: `
        @use "variables" as *;

        :host {
            display: block;
            width: 100%;
        }

        .categories-grid {
            display: flex;
            flex-wrap: wrap;
            gap: 0.75rem;
            align-items: flex-start;

            @media screen and (max-width: 768px) {
                display: grid;
                grid-template-rows: repeat(2, auto);
                grid-auto-flow: column;
                gap: 0.5rem;
                overflow-x: auto;
                overflow-y: hidden;
                -webkit-overflow-scrolling: touch;
                scrollbar-width: none;
                -ms-overflow-style: none;

                &::-webkit-scrollbar {
                    display: none;
                }
            }
        }

        .category-btn {
            display: inline-flex;
            align-items: center;
            border-radius: 6px !important;
            justify-content: center;
            padding: 0.65rem 1.5rem;
            background-color: $light-blue;
            color: #0C0C3A;
            text-decoration: none;
            font-weight: 600;
            font-size: 16px;
            text-transform: uppercase;
            letter-spacing: 0.02em;
            border-radius: 4px;
            transition: background-color 200ms ease, color 200ms ease;
            white-space: nowrap;

            &:hover {
                background-color:$red;
                color: #fff;
            }

            @media screen and (max-width: 768px) {
                padding: 0.5rem 1rem;
                font-size: 0.75rem;
            }
        }
    `,
    template: `
        <div class="categories-grid">
            @for (category of categories; track category.id) {
                <a class="category-btn" [routerLink]="[AppRoutes.Categories, category.id]">
                    {{ category.name }}
                </a>
            }
        </div>
    `
})
export class CategoriesComponent {
    public AppRoutes = AppRoute;
    public categories = CATEGORIES;
}
